import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyle } from './PrequalStyle.js';
export default function EirPrequalInputTitle(props) {
  const classes = useStyle();
  let defaultProps = {
    title: props.title,
    text: props.text,
  };
  return (
    <Grid className={classes.PrequalLeftPart}>
      <Typography className={classes. PrequalHeadingText}
       style={{color: props.fontColor}}
      >
        {defaultProps.title}
      </Typography>

      <Typography className={classes.PrequalSubHeadingText}
      style={{color: props.fontColor}}
      >
        {defaultProps.text}
      </Typography>
    </Grid>
  );
}
